import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { useLang } from '../../context/LangContext';
import enTexts from '../../translations/en.json';
import esTexts from '../../translations/es.json';

const Home = () => {
  const { lang } = useLang();
  const texts = lang === 'en' ? enTexts : esTexts;

  return (
    <div className="home-container">
      {/* Top / Left Section - Blue */}
      <div className="home-section section-incoming">
        <div className="home-content text-center">
          <div className="home-icon mb-3">
            <div className="home-icon-badge">
              <i className="fa fa-plane"></i>
            </div>
            <div className="icon-text mt-2">{texts.home.incoming_subtitle}</div>
          </div>
          <h1 className="home-title mb-3">
            <span className="fw-normal">{texts.home.incoming_title_1}</span>{' '}
            <strong>{texts.home.incoming_title_2}</strong>
          </h1>
          <p className="home-desc mb-4 mx-auto">{texts.home.incoming_desc}</p>
          <Link to="/wizard/incoming" className="home-btn btn-incoming">
            {texts.home.incoming_btn}
          </Link>
        </div>
      </div>

      {/* Bottom / Right Section - Orange */}
      <div className="home-section section-outgoing">
        <div className="home-content text-center">
          <div className="home-icon mb-3">
            <div className="home-icon-badge">
              <i className="fa fa-globe"></i>
            </div>
            <div className="icon-text mt-2">{texts.home.outgoing_subtitle}</div>
          </div>
          <h1 className="home-title mb-3">
            <span className="fw-normal">{texts.home.outgoing_title_1}</span>{' '}
            <strong>{texts.home.outgoing_title_2}</strong>
          </h1>
          <p className="home-desc mb-4 mx-auto">{texts.home.outgoing_desc}</p>
          <Link to="/wizard/outgoing" className="home-btn btn-outgoing">
            {texts.home.outgoing_btn}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
